export default __webpack_public_path__ + "static/bn-4442912fb5ca65ba9dad8d0add8a46fd.svg";